import React, { FC, useEffect, useRef } from 'react'

import { ArrowRightIcon, IconSizes, IconWeight } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './FullTourIntro.module.scss'
import { FullTourIntroProps } from './FullTourIntro.types'

export const FullTourIntro: FC<FullTourIntroProps> = ({ onSkip, onStart }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour'
  })
  const startButtonRef = useRef<HTMLButtonElement>(null)
  const steps = t('steps', { returnObjects: true }) as string[]

  useEffect(() => {
    startButtonRef.current?.focus()
  }, [])

  return (
    <section
      className={styles.card}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-title'
      aria-describedby='full-tour-description'
    >
      <div className={styles.content}>
        <div className={styles.intro}>
          <div className={styles.heading}>
            <p className={styles.eyebrow}>{t('eyebrow')}</p>
            <h1 id='full-tour-title' className={styles.title}>
              <span>{t('title_before')}</span>{' '}
              <span className={styles.titleHighlight}>
                {t('title_highlighted')}
              </span>
            </h1>
          </div>

          <p id='full-tour-description' className={styles.description}>
            {t('description')}
          </p>
        </div>

        <ul className={styles.steps} aria-label={t('steps_label')}>
          {steps.map(step => (
            <li key={step} className={styles.step}>
              {step}
            </li>
          ))}
        </ul>

        <div className={styles.actions}>
          <button
            ref={startButtonRef}
            type='button'
            className={styles.startButton}
            onClick={onStart}
          >
            <span>{t('start_button')}</span>
            <ArrowRightIcon
              aria-hidden='true'
              color='var(--primary-blue-light)'
              size={IconSizes.Size18}
              weight={IconWeight.Bold}
            />
          </button>
          <button type='button' className={styles.skipButton} onClick={onSkip}>
            {t('skip_button')}
          </button>
        </div>
      </div>
    </section>
  )
}
